<template>
  <vx-tooltip class="w-3 h-3 min-w-3 rounded-full"
              :class="published ? 'bg-success' : 'border-2 border-solid border-gray-dark'"
              :position="tooltipPosition"
              :title="tooltipTitle"
              :text="tooltipText"
  />
</template>

<script>
import { PUBLISHED_ANSWER_TOOLTIP_TEXT, PUBLISHED_ANSWER_TOOLTIP_TITLE } from '@/utils/text.constants'

export default {
  name: 'AnswerPublishedStatus',

  props: {
    published: { type: Boolean, default: false },
    isUnknownAnswer: { type: Boolean, required: true },
    tooltipPosition: { type: String, default: 'top' }
  },

  computed: {
    tooltipTitle() {
      return this.published ? PUBLISHED_ANSWER_TOOLTIP_TITLE.PUBLISHED : PUBLISHED_ANSWER_TOOLTIP_TITLE.NOT_PUBLISHED
    },

    tooltipText() {
      if (this.isUnknownAnswer) return PUBLISHED_ANSWER_TOOLTIP_TEXT.UNKNOWN_ANSWER
      
      return this.published ? PUBLISHED_ANSWER_TOOLTIP_TEXT.PUBLISHED : PUBLISHED_ANSWER_TOOLTIP_TEXT.NOT_PUBLISHED
    }
  }
}
</script>
